





























































































import { Vue, Component, Mixins } from "vue-property-decorator";
import _ from "lodash";
import MyList from "@/mixins/list";

@Component
export default class extends Mixins(MyList) {
  dispatchType: string = "admin/templatemessage";
  moreInfoVisible: boolean = false;

  ModalText: string = "";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "标题", dataIndex: "tpl_title" },
    { title: "微信应用", dataIndex: "app_name" },
    { title: "内容", scopedSlots: { customRender: "content" } },
    { title: "时间", dataIndex: "created_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData({}, false);
  }

  renderTplContent(tplContent: string, tplData: string) {
    const data = JSON.parse(tplData);
    // console.log(data);
    tplContent = tplContent.replace(/\n/g, "<br />");
    tplContent = _.replace(
      tplContent,
      `{{first.DATA}}`,
      data.first ? _.truncate(data.first.value, { length: 150 }) : ""
    );
    tplContent = _.replace(
      tplContent,
      `{{keyword1.DATA}}`,
      data.keyword1 ? _.truncate(data.keyword1.value, { length: 150 }) : ""
    );
    tplContent = _.replace(
      tplContent,
      `{{keyword2.DATA}}`,
      data.keyword2 ? _.truncate(data.keyword2.value, { length: 150 }) : ""
    );

    tplContent = _.replace(
      tplContent,
      `{{keyword3.DATA}}`,
      data.keyword3 ? _.truncate(data.keyword3.value, { length: 150 }) : ""
    );

    tplContent = _.replace(
      tplContent,
      `{{keyword4.DATA}}`,
      data.keyword4 ? _.truncate(data.keyword4.value, { length: 150 }) : ""
    );

    tplContent = _.replace(
      tplContent,
      `{{keyword5.DATA}}`,
      data.keyword5 ? _.truncate(data.keyword5.value, { length: 150 }) : ""
    );

    tplContent = _.replace(
      tplContent,
      `{{remark.DATA}}`,
      data.remark ? _.truncate(data.remark.value, { length: 150 }) : ""
    );
    return tplContent;
  }

  renderTplContent1(tplContent: string, tplData: string) {
    const data = JSON.parse(tplData);
    // console.log(data);
    tplContent = tplContent.replace(/\n/g, "<br />");
    tplContent = _.replace(tplContent, `{{first.DATA}}`, data.first ? data.first.value : "");
    tplContent = _.replace(
      tplContent,
      `{{keyword1.DATA}}`,
      data.keyword1 ? data.keyword1.value : ""
    );
    tplContent = _.replace(
      tplContent,
      `{{keyword2.DATA}}`,
      data.keyword2 ? data.keyword2.value : ""
    );

    tplContent = _.replace(
      tplContent,
      `{{keyword3.DATA}}`,
      data.keyword3 ? data.keyword3.value : ""
    );

    tplContent = _.replace(
      tplContent,
      `{{keyword4.DATA}}`,
      data.keyword4 ? data.keyword4.value : ""
    );

    tplContent = _.replace(
      tplContent,
      `{{keyword5.DATA}}`,
      data.keyword5 ? data.keyword5.value : ""
    );

    tplContent = _.replace(tplContent, `{{remark.DATA}}`, data.remark ? data.remark.value : "");
    return tplContent;
  }

  showMoreInfo(record: any) {
    this.ModalText = this.renderTplContent1(record.tpl_content, record.extra);
    this.moreInfoVisible = true;
  }

  hideMoreInfo() {
    this.ModalText = "";
    this.moreInfoVisible = false;
  }
}
